import { render, staticRenderFns } from "./EntityContactCreate.vue?vue&type=template&id=da1686f8"
import script from "./EntityContactCreate.vue?vue&type=script&lang=js"
export * from "./EntityContactCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports